import { makeStyle } from '../../../../utils';
import { subTitle1, black, caption, blackMedium, secondary } from '../../../../resources/styles';

const styles = {};

styles['container'] = makeStyle({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: 6,
    padding: 16,
    boxSizing: 'border-box',
    textAlign: 'center',
});

styles['image'] = makeStyle({
    width: 96,
    height: 96,
});

styles['title'] = makeStyle({ ...subTitle1, ...black, marginTop: 16 });

styles['description'] = makeStyle({ ...caption, letterSpacing: '0.2px', ...blackMedium, marginTop: 8 });

styles['view_more'] = makeStyle({ ...caption, letterSpacing: '0.2px', ...secondary, marginTop: 8, cursor: 'pointer' });

export default styles;